import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';

import { InfiniteScroll } from '../../components/infinitescroll';
import {
  getNodes,
  CompanyUserGroupsOnPlatformQuery,
  CompanyUserGroupsOnPlatformQueryVariables,
  PAGINATION_PAGE_SIZE,
  loadMoreFromConnection,
} from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { UserGroupsOnPlatformView } from '../components/user_groups_on_platform';
import { UserGroupOnPlatform } from '../entities';
import { companyUserGroupsQuery } from '../graphql';

class LoadingContainer extends Loader<
  CompanyUserGroupsOnPlatformQuery,
  { userGroupsOnPlatform: UserGroupOnPlatform[] },
  CompanyUserGroupsOnPlatformQueryVariables
> {}

export const CompanyUserGroupsContainer = () => {
  const { company_id } = useParams() as { company_id: string };

  const result = useQuery<CompanyUserGroupsOnPlatformQuery, CompanyUserGroupsOnPlatformQueryVariables>(
    companyUserGroupsQuery,
    {
      variables: {
        limit: PAGINATION_PAGE_SIZE,
        company_id,
      },
    },
  );

  return (
    <LoadingContainer
      result={result}
      mapData={({ data }) => ({
        userGroupsOnPlatform: (getNodes(data.company?.userGroupsOnPlatform) ?? []).map((group) => ({
          ...group,
          company: group.company ?? undefined,
        })),
      })}>
      {({ userGroupsOnPlatform }) => (
        <InfiniteScroll
          triggerOnWindow={false}
          loadMoreEntries={() =>
            loadMoreFromConnection(companyUserGroupsQuery, result, ['company', 'userGroupsOnPlatform'])
          }>
          <UserGroupsOnPlatformView userGroupsOnPlatform={userGroupsOnPlatform} company_id={company_id} />
        </InfiniteScroll>
      )}
    </LoadingContainer>
  );
};
